import React from 'react';

import './styles.scss'

import {PageTitleText} from "../../Typography";
import {MerchantRequestError} from "../../InputsHelpers";
import {BtnBack} from "../../Buttons";

export default ({title, backFN, formCtx, leftBlock, rightBlock}) => {
  return (
    <div className="page-header">
      <div className="page-header__left-block">
        {backFN && (
          <div className="page-header__back-btn">
            <BtnBack onClick={backFN} />
          </div>
        )}
        <div className="page-header__title">
          <PageTitleText>{title}</PageTitleText>
        </div>
        {leftBlock}
        {formCtx && (
          <div className="page-header__request-error">
            <MerchantRequestError formCtx={formCtx} />
          </div>
        )}
      </div>
      {rightBlock}
    </div>
  )
}
